document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".slider").forEach(function (slider) {
      const container = slider.querySelector(".slides");
      const slides = container.querySelectorAll(".slide");
      const arrows = slider.querySelectorAll(".arrow");
      const totalSlides = slides.length;

      arrows.forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          const direction = btn.classList.contains("left") ? -1 : 1;
          const slideWidth = container.clientWidth;
          const scrollLeft = container.scrollLeft;

          // Calcule l'index actuel
          const currentIndex = Math.round(scrollLeft / slideWidth);
          const nextIndex = currentIndex + direction;

          if (nextIndex < 0) {
            // Rebond brut vers la fin si on est à gauche de 0
            container.scrollTo({ left: (totalSlides - 1) * slideWidth, behavior: 'auto' });
          } else if (nextIndex >= totalSlides) {
            // Rebond brut vers le début si on dépasse la droite
            container.scrollTo({ left: 0, behavior: 'auto' });
          } else {
            // Défilement normal
            container.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
          }
        });
      });

      // Cacher flèches si une seule image
      if (totalSlides <= 1) {
        slider.classList.add("only-one-image");
      }
    });
  });